const translates: { [key: string]: { id: string } } = {
  assigned: { id: 'assigned' },
  users: { id: 'users' },
  teams: { id: 'teams' },
  noResultsMessage: { id: 'no_results' },
  search: { id: 'search' },
}

export default translates
